/**
 * Tecla F10 global — origem no banco (LIST_F1).
 *
 * Qualquer input com `data-db-table` / `data-db-field` (ou R3Input com
 * props dbTable/dbField, que gravam esses atributos) abre o diálogo.
 * `preventDefault` evita o menu do navegador no F10.
 */
export default defineNuxtPlugin(() => {
	if (!import.meta.client) return;

	const onKeyDown = (e: KeyboardEvent) => {
		if (e.key !== "F10") return;

		// Só age se o foco estiver em campo de entrada (ou descendente com data-db-*).
		const alvo = document.activeElement;
		if (!alvo || alvo === document.body) return;

		const { showFieldDbInfoFromFocus } = useFieldDbInfo();
		const abriu = showFieldDbInfoFromFocus(alvo);
		if (abriu) {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	document.addEventListener("keydown", onKeyDown, true);

	if (import.meta.hot) {
		import.meta.hot.dispose(() => {
			document.removeEventListener("keydown", onKeyDown, true);
		});
	}
});
